import { confirmDialog, type ConfirmDialogProps } from "primereact/confirmdialog";

type ConfirmAsyncArgs = Pick<
  ConfirmDialogProps,
  "message" | "header" | "icon" | "acceptLabel" | "rejectLabel" | "defaultFocus"
>;

/**
 * Promise-based wrapper around PrimeReact's confirmDialog.
 * Keeps callsites small and avoids duplicating accept/reject callback wiring.
 */
export function confirmAsync(args: ConfirmAsyncArgs): Promise<boolean> {
  return new Promise((resolve) => {
    let settled = false;
    const settle = (value: boolean) => {
      if (settled) return;
      settled = true;
      resolve(value);
    };

    confirmDialog({
      ...args,
      accept: () => settle(true),
      reject: () => settle(false),
      onHide: () => settle(false),
    });
  });
}


